import { render, staticRenderFns } from "./Banner3.vue?vue&type=template&id=4e42748a"
import script from "./Banner3.vue?vue&type=script&lang=js"
export * from "./Banner3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports